import { patchWebCodecsHardwarePreference } from '@/utils/xmovAvatar'

// 微信内打开数字人 SDK 前尽早注入 Worker/WebCodecs 兼容补丁
patchWebCodecsHardwarePreference()

import { createApp } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import { Button, Form, Field, CellGroup, Toast, Dialog, Tabbar, TabbarItem, NavBar, Icon, Loading, Popup } from 'vant'
import 'vant/lib/index.css'
import './styles/vant-icon-fix.css'
import './styles/highdpi-page-scale.css'
import './styles/phone-rotate-overlay.css'
import './styles/bilingual.css'
import { ENABLE_ENGLISH } from '@/config/bilingual'
import App from './App.vue'
import router from './router'
import api from './api'
import jweixin from 'weixin-js-sdk'
import { installDevtoolsGuard } from '@/utils/devToolsGuard'
import { appFullPath } from '@/utils/appPublicPath'

async function bootstrap() {
  installDevtoolsGuard()

  if (typeof document !== 'undefined' && ENABLE_ENGLISH) {
    document.documentElement.classList.add('bilingual-enabled')
  }

  const app = createApp(App)
  const pinia = createPinia()
  setActivePinia(pinia)

  app.config.globalProperties.$api = api
  app.use(pinia)

  app.use(Button)
  app.use(Form)
  app.use(Field)
  app.use(CellGroup)
  app.use(Toast)
  app.use(Dialog)
  app.use(Tabbar)
  app.use(TabbarItem)
  app.use(NavBar)
  app.use(Icon)
  app.use(Loading)
  app.use(Popup)
  app.use(router)

  window.wx = jweixin

  app.mount('#app')

  if (typeof window !== 'undefined') {
    window.addEventListener('popstate', () => {
      const router = app.config.globalProperties.$router
      const currentPath = window.location.pathname
      const isButtonNavigation = sessionStorage.getItem('button_navigation')

      if (isButtonNavigation === 'true') {
        sessionStorage.removeItem('button_navigation')
        return
      }

      if (!/\/home\/?$/.test(currentPath)) {
        router.replace('/home')
      }
    })
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('popstate', () => {
      const currentPath = window.location.pathname
      const isButtonNavigation = sessionStorage.getItem('button_navigation')

      if (isButtonNavigation === 'true') {
        sessionStorage.removeItem('button_navigation')
        return
      }

      if ((currentPath.includes('/quiz/room') || currentPath.includes('/quiz/random') ||
          currentPath.includes('/quiz/friend') || currentPath.includes('/quiz/result'))) {
        window.history.replaceState(null, '', appFullPath('/home'))
        if (router) {
          router.replace('/home')
        }
      }
    })
  }
}

bootstrap()
